import { useQuery } from '@tanstack/react-query'
import { CountResponse, DetailSearchConfigEntry } from '../utils/detailSearchConfig'

interface UseDetailSearchCountParams {
    type: string
    config: DetailSearchConfigEntry
    criteria: Record<string, unknown>
    enabled: boolean
}

export const useDetailSearchCount = ({ type, config, criteria, enabled }: UseDetailSearchCountParams) => {
    return useQuery<CountResponse>({
        queryKey: ['detailSearchCount', type, criteria],
        queryFn: () => config.fetchCount(criteria),
        enabled,
        select: (data) => ({ count: data?.count ?? 0 }),
    })
}
